import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Table,
  Empty,
  Button,
  Input,
  Select,
  Checkbox,
  notification,
  Form,
  Popover,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { useProyectos } from "../../../../hooks/useProyectos";
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
import { ModalBeneficiarios } from "../../../Admin/SeguimientoProyectos/modal-beneficiarios"; 
import { VerMasProyectos } from "../../../Admin/SeguimientoProyectos/VerMasProyectos";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { TemplateContext } from "../../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";
import GetStorageUser from "../../../../middlewares/GetStorageUser";

export const Proyectos = () => {
  let {
    proyectos,
    cambiarCantidadPaginas,
    cantidadPaginas,
    obtenerLineaConvocatoria,
    obtenerProyectosUsuario,
    loading,
  } = useProyectos();

  useEffect(() => {
    const user = GetStorageUser();
    setUser(user);
    obtenerProyectosUsuario(user);
    obtenerLineaConvocatoria();
  }, []);

  const TipoDocumento: any = {
    "1": "CC",
    "3": "CC",
    "2": "NIT",
  }

  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Nombre de proyecto",
      width: 220,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) => <span>{data?.nombre_propuesta?.length > 27 ? `${data?.nombre_propuesta?.substring(0, 27)}...` : data?.nombre_propuesta}</span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 80,
      render: (data: any) => <span>{data?.estado}</span>,
    },
    {
      title: "Linea",
      width: 170,
      ellipsis: true,
      render: (data: any) => {
        return <span>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
          <>
            <span style={{whiteSpace: "pre-line"}}>{datos.categoria_linea_convocatoria}</span>
          </>
        );
      },
    },
    {
      title: "Tipo de Documento",
      width: 100,
      render: (data: any) => <span>{TipoDocumento[data?.postulacion?.tipo_participante]}</span>,
    },
    {
      title: "Documento",
      width: 100,
      render: (data: any) => <span>{data?.postulacion?.numero_documento_participante}</span>,
    },
    {
      title: "Puntaje final",
      width: 100,
      whiteSpace: "nowrap",
      className: "white-space-nowrap",
      style: {whiteSpace: "nowrap"},
      render: (data: any) => <span>{data?.nota_final}</span>,
      key: "final",
      fixed: context.device === "lg" ? "right" : false,
    },
    {
      title: () => (
        <Row style={{ width: '100px' }}>
          <Col span={24} className="justify-content-center">
            Acciones
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <Row style={{ width: '100' }}>
            <Col span={24} style={{ justifyContent: 'center' }}>
              <Button
                onClick={() => verMas(datos)}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
            </Col>
          </Row>
        </>
      ),
    }
  ];

  const [verMasOpen, setVerMasOpen] = useState(false);
  const [user, setUser] = useState<any>()
  const [datos, setDatos] = useState({
    nombre_propuesta: "",
    radicado: "",
    linea_convocatoria: "",
    categoria_linea_convocatoria: [{ text: "" }],
    jurados: [],
  });
  const verMas = (datos: any) => {
    setVerMasOpen(true);
    setDatos(datos);
  };

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };

  return (
        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div
                className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular"
                style={{ paddingBottom: "0%" }}
              >
                Lista de resultados de evaluaciones
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex justify-content-end">
                  <div>
                    Total:{" "}
                    <span className="font-color-F28C02">
                      {proyectos.length}
                    </span>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </label>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPaginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg/>
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadPaginas,
                  }}
                  dataSource={proyectos}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        

      {verMasOpen && (
        <VerMasProyectos
          openModal={verMasOpen}
          setOpenModal={setVerMasOpen}
          datos={datos}
        />
      )}
      </div>
  );
};
